<template>
  <div class="home" :style="homeBgStyle">
    <main class="home__main">
      <section class="mod1" aria-label="首页标题区">
        <img class="mod1__logo" :src="img.logoMain" alt="自媒V发布" />
        <img
          class="mod1__subtitle"
          :src="img.subtitle"
          alt="金融自媒体人才库"
        />
      </section>

      <section class="mod2" aria-label="平台介绍">
        <img
          class="mod2__title"
          :src="img.mod2Title"
          alt="链接百万自媒体力量，共创行业新生态"
        />
        <img
          class="mod2__body"
          :src="img.mod2Body"
          alt="基于人工智能大数据驱动，构建成都自媒体供需匹配闭环生态，助力品牌价值与内容创作的精准转化"
        />
        <img class="mod2__digits" :src="img.digits" alt="数据展示" />
      </section>

      <section v-if="currentPolicyImage && nextPolicyImage" class="mod4" aria-label="扶持八条与共识九条">
        <div class="mod4__stack" :style="policyStackStyle" @click="openPolicyModal">
          <img
            class="mod4__card mod4__card--next"
            :class="{ 'is-hidden': policyFading }"
            :src="nextPolicyImage.src"
            :alt="nextPolicyImage.alt"
          />
          <img
            class="mod4__card mod4__card--current"
            :src="currentPolicyImage.src"
            :alt="currentPolicyImage.alt"
          />
        </div>
      </section>

      <div
        v-if="policyModalVisible"
        class="policy-modal"
        role="dialog"
        aria-modal="true"
        aria-label="扶持八条与共识九条全部内容"
        @click.self="closePolicyModal"
      >
        <div class="policy-modal__panel">
          <button type="button" class="policy-modal__close" @click="closePolicyModal">关闭</button>
          <div class="policy-modal__list">
            <img
              v-for="item in policyImages"
              :key="item.alt"
              class="policy-modal__img"
              :src="item.src"
              :alt="item.alt"
            />
          </div>
        </div>
      </div>
    </main>

    <div class="home__bottom-bar">
      <div class="home__login-bar">
        <button
          type="button"
          class="home__login-btn"
          :class="{ 'home__login-btn--logged-in': isLoggedIn }"
          :style="loginBtnBgStyle"
          :aria-label="ctaLabel"
          @click="onCtaClick"
        >
          {{ ctaLabel }}
        </button>
      </div>
      <footer class="home__icp">
        <a
          class="home__icp-link"
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >蜀ICP备2025150450号-2</a>
      </footer>
    </div>
  </div>
</template>

<script>
/**
 * partnerLogos 保持列表顺序：财达、德讯、…、约牛。
 * 圆环顺序由 PARTNER_ARC_ORDER（优品→…→财达→约牛→再接优品）。
 * 沿参数角平移整链（rep×n×步长）闭合拼接。rep 与 rep+2 同槽在 mod360 下只差约 4°，会严重叠图；
 * 故只渲染相邻两个整数 rep（随 orbitDeg 滑动），间距仍为 PARTNER_ORBIT_STEP_DEG。
 */
/** 槽位 slot 对应 partnerLogos 的下标，长度须与 partnerLogos 一致 */
const PARTNER_ARC_ORDER = Object.freeze([5, 4, 3, 2, 1, 0, 6])
/** 华泰在 partnerLogos 中下标为 3，其在 PARTNER_ARC_ORDER 中的槽位为 2，orbitDeg=0 时对准条带中心 */
const CENTER_SLOT_INDEX = 2
/** 相邻槽位参数角间隔（度），调疏密 */
const PARTNER_ORBIT_STEP_DEG = 26
/** 合作伙伴.png 设计稿宽度（像素），半径 = 该图宽 / 2，再按条带宽度等比 */
const PARTNER_REF_PX_W = 3493
/** 合作伙伴背景.png 设计高/宽，用于未加载出高度时估算条带高度 */
const PARTNER_BG_H_PER_W = 346 / 1125
/** 在「合作伙伴.png 半宽」等比半径上再放大，可调大/小 */
const ORBIT_R_SCALE = 1.18
/** 椭圆半轴：在基准 R 上乘系数，Rx>Ry 时弧更「横向扁椭圆」 */
const ORBIT_ELLIPSE_RX = 1.18
const ORBIT_ELLIPSE_RY = 0.82
/** 沿椭圆走一圈的时长（毫秒），越大越慢越顺滑感 */
const ORBIT_PERIOD_MS = 95000
/** 圆心相对公式再往上移的像素（越大越靠上） */
const ARC_PIVOT_RAISE_PX = 29
const POLICY_SWITCH_MS = 5200
const POLICY_NEXT_OFFSET = 8.3333
const POLICY_SWITCH_HIDE_MS = 220

function _loadPolicyImages() {
  const groups = [
    {
      label: '扶持八条',
      ctx: (() => {
        try {
          return require.context('@component/扶持八条', false, /\.(png|jpe?g|webp)$/i)
        } catch (_) {
          return null
        }
      })()
    },
    {
      label: '共识九条',
      ctx: (() => {
        try {
          return require.context('@component/共识九条', false, /\.(png|jpe?g|webp)$/i)
        } catch (_) {
          return null
        }
      })()
    }
  ]
  const result = []
  groups.forEach(({ ctx, label }) => {
    if (!ctx) return
    const keys = ctx.keys().slice().sort((a, b) => a.localeCompare(b, 'zh-Hans-CN'))
    keys.forEach((k) => {
      const pureName = k.replace('./', '').replace(/\.(png|jpe?g|webp)$/i, '')
      result.push({
        src: ctx(k),
        alt: `${label}-${pureName}`
      })
    })
  })
  return result
}

export default {
  name: 'LanhuHuaban1',
  data() {
    return {
      img: {
        bg: require('@component/背景.png'),
        logoMain: require('@component/自媒v发布.png'),
        subtitle: require('@component/金融自媒体人才库.png'),
        mod2Title: require('@component/链接百万自媒体力量，共创行业新生态.png'),
        mod2Body: require(
          '@component/基于人工智能大数据驱动，构建成都自媒体供需匹配闭环生态， 助力品牌价值与内容创作的精准转化.png'
        ),
        digits: require('@component/数字.png'),
        partnerBg: require('@component/合作伙伴背景.png'),
        loginBtnBg: require('@component/登录按钮背景.png')
      },
      orbitDeg: 0,
      /** 基准半径（用于圆心 y = R + 背景中心y） */
      orbitR: 200,
      /** 椭圆水平/垂直半轴（px），logo 轨迹用 parametric 椭圆 */
      orbitRx: 200,
      orbitRy: 170,
      /** 圆心 y（px）：条带中心 y + Ry，使中间 logo（θ=0）落在背景几何中心 */
      arcPivotTopPx: 0,
      rafId: null,
      /** rAF 时间轴起点，用于匀速角速度 */
      arcSpinStartMs: 0,
      orbitPaused: false,
      /** 与 Login.vue 写入的 sessionStorage「loginUser」同步 */
      isLoggedIn: false,
      partnerLogos: [
        { src: require('@component/财达证券.png'), alt: '财达证券' },
        { src: require('@component/德讯证券.png'), alt: '德讯证券' },
        { src: require('@component/和讯.png'), alt: '和讯' },
        { src: require('@component/华泰证券.png'), alt: '华泰证券' },
        { src: require('@component/钱坤云.png'), alt: '钱坤云' },
        { src: require('@component/优品证券.png'), alt: '优品证券' },
        { src: require('@component/约牛证劵.png'), alt: '约牛证券' }
      ],
      policyImages: _loadPolicyImages(),
      policyIndex: 0,
      policyFading: false,
      policyTimer: null,
      policyHideTimer: null,
      policyModalVisible: false
    }
  },
  computed: {
    homeBgStyle() {
      return {
        backgroundImage: `url(${this.img.bg})`
      }
    },
    loginBtnBgStyle() {
      return {
        backgroundImage: `url(${this.img.loginBtnBg})`
      }
    },
    ctaLabel() {
      return this.isLoggedIn ? '个人中心' : '登录'
    },
    /** 圆心 x = 条带水平中心（背景宽的一半） */
    arcPivotStyle() {
      return {
        left: '50%',
        top: `${this.arcPivotTopPx}px`,
        transform: 'translateX(-50%)'
      }
    },
    /**
     * 只渲染相邻整数 rep、rep+1（链上仍为 PARTNER_ORBIT_STEP_DEG）。
     * rep 与 rep+2 同槽在 mod360 下只差约 4°，多叠几组会严重重叠，故不能固定 -2..2。
     * repMid 用 -round(orbitDeg/period)，避免 floor(-ε) 在 orbitDeg>0 时误成 -1。
     */
    partnerArcRingItems() {
      const n = this.partnerLogos.length
      if (!n || PARTNER_ARC_ORDER.length !== n) return []
      const period = n * PARTNER_ORBIT_STEP_DEG
      const repMid = -Math.round(this.orbitDeg / period)
      const items = []
      for (let rep = repMid; rep <= repMid + 1; rep++) {
        for (let slot = 0; slot < n; slot++) {
          items.push({ key: `${rep}-s${slot}`, rep, slot })
        }
      }
      return items
    },
    currentPolicyImage() {
      if (!this.policyImages.length) return null
      return this.policyImages[this.policyIndex % this.policyImages.length]
    },
    nextPolicyImage() {
      if (!this.policyImages.length) return null
      const n = this.policyImages.length
      return this.policyImages[(this.policyIndex + 1) % n]
    },
    policyStackStyle() {
      return {
        '--policy-next-offset': `${POLICY_NEXT_OFFSET}%`
      }
    }
  },
  mounted() {
    this.syncLoginFromStorage()
    window.addEventListener('storage', this.onLoginStorageChanged)
    window.addEventListener('pageshow', this.onPageShowResume)
    this.orbitPaused =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    window.addEventListener('resize', this.updateArcMetrics, { passive: true })
    this.$nextTick(() => {
      this.updateArcMetrics()
      const bg = this.$refs.mod3Bg
      if (bg && bg.complete) {
        this.updateArcMetrics()
      }
      this.startArcSpin()
      this.startPolicyCarousel()
    })
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.onLoginStorageChanged)
    window.removeEventListener('pageshow', this.onPageShowResume)
    window.removeEventListener('resize', this.updateArcMetrics)
    this.stopArcSpin()
    this.stopPolicyCarousel()
  },
  methods: {
    onPartnerBgLoad() {
      this.$nextTick(() => this.updateArcMetrics())
    },
    baseAngleDegForSlot(slot) {
      return (slot - CENTER_SLOT_INDEX) * PARTNER_ORBIT_STEP_DEG
    },
    partnerArcLogoAt(slot) {
      return this.partnerLogos[PARTNER_ARC_ORDER[slot]]
    },
    arcNodeStyle(rep, slot) {
      const n = this.partnerLogos.length
      const periodShift = rep * n * PARTNER_ORBIT_STEP_DEG
      const deg =
        this.orbitDeg + this.baseAngleDegForSlot(slot) + periodShift
      const rad = (deg * Math.PI) / 180
      const x = this.orbitRx * Math.sin(rad)
      const y = -this.orbitRy * Math.cos(rad)
      return {
        transform: `translate(${x.toFixed(2)}px, ${y.toFixed(2)}px)`
      }
    },
    updateArcMetrics() {
      const panel = this.$refs.mod3Panel
      const bg = this.$refs.mod3Bg
      if (!panel || typeof panel.offsetWidth !== 'number') return
      const w = panel.offsetWidth
      const R = Math.max(
        1,
        Math.round(
          ((w * (PARTNER_REF_PX_W / 2)) / PARTNER_REF_PX_W) * ORBIT_R_SCALE
        )
      )
      this.orbitR = R
      this.orbitRx = Math.max(1, Math.round(R * ORBIT_ELLIPSE_RX))
      this.orbitRy = Math.max(1, Math.round(R * ORBIT_ELLIPSE_RY))
      let hStrip = 0
      if (bg && bg.offsetHeight > 0) {
        hStrip = bg.offsetHeight
      } else if (panel.offsetHeight > 0) {
        hStrip = panel.offsetHeight
      } else {
        hStrip = Math.round(w * PARTNER_BG_H_PER_W)
      }
      const bgCenterY = hStrip / 2
      // 椭圆心在条带中心下方；减 ARC_PIVOT_RAISE_PX 可把圆心上移微调
      this.arcPivotTopPx = Math.round(
        bgCenterY + this.orbitRy - ARC_PIVOT_RAISE_PX
      )
    },
    startArcSpin() {
      if (this.orbitPaused) return
      this.arcSpinStartMs = performance.now()
      const tick = () => {
        const t = performance.now() - this.arcSpinStartMs
        const phase = ((t / ORBIT_PERIOD_MS) * 360) % 360
        this.orbitDeg = (360 - phase) % 360
        this.rafId = window.requestAnimationFrame(tick)
      }
      this.rafId = window.requestAnimationFrame(tick)
    },
    stopArcSpin() {
      if (this.rafId != null) {
        window.cancelAnimationFrame(this.rafId)
        this.rafId = null
      }
    },
    syncLoginFromStorage() {
      try {
        const raw = sessionStorage.getItem('loginUser')
        if (!raw) {
          this.isLoggedIn = false
          return
        }
        const u = JSON.parse(raw)
        this.isLoggedIn = !!(
          u &&
          typeof u === 'object' &&
          ((u.user_id && String(u.user_id).trim()) ||
            (u.user_phone && String(u.user_phone).trim()))
        )
      } catch (_) {
        this.isLoggedIn = false
      }
    },
    onLoginStorageChanged(e) {
      if (e.key === 'loginUser') this.syncLoginFromStorage()
    },
    onPageShowResume(ev) {
      if (ev.persisted) this.syncLoginFromStorage()
    },
    openPolicyModal() {
      this.policyModalVisible = true
      this.stopPolicyCarousel()
    },
    closePolicyModal() {
      this.policyModalVisible = false
      this.startPolicyCarousel()
    },
    onCtaClick() {
      if (!this.$router) return
      const name = this.isLoggedIn ? 'user' : 'login'
      this.$router.push({ name }).catch(() => {})
    },
    startPolicyCarousel() {
      this.stopPolicyCarousel()
      if (this.policyImages.length <= 1) return
      this.policyTimer = window.setInterval(() => {
        if (this.policyFading) return
        this.policyFading = true
        this.policyHideTimer = window.setTimeout(() => {
          this.policyIndex = (this.policyIndex + 1) % this.policyImages.length
          this.policyFading = false
          this.policyHideTimer = null
        }, POLICY_SWITCH_HIDE_MS)
      }, POLICY_SWITCH_MS)
    },
    stopPolicyCarousel() {
      if (this.policyTimer != null) {
        window.clearInterval(this.policyTimer)
        this.policyTimer = null
      }
      if (this.policyHideTimer != null) {
        window.clearTimeout(this.policyHideTimer)
        this.policyHideTimer = null
      }
      this.policyFading = false
    }
  }
}
</script>

<style scoped>
.home {
  --main-pad-x: clamp(16px, 4vw, 40px);
  position: relative;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  box-sizing: border-box;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% auto;
  background-attachment: scroll;
  height: calc(100vw * 2436 / 1125);
  min-height: 0;
  padding-bottom: 0;
  overflow: hidden;
}

.home__main {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(40px, 8vh, 88px);
  padding-top: clamp(40px, 10vh, 120px);
  padding-bottom: clamp(40px, 10vh, 120px);
  padding-left: var(--main-pad-x);
  padding-right: var(--main-pad-x);
}

@media (min-width: 900px) {
  .home {
    --main-pad-x: clamp(28px, 3.2vw, 56px);
    width: 100%;
    max-width: 100%;
    height: calc(100vw * 2436 / 1125);
    min-height: 0;
    padding-bottom: 0;
  }

  .home__main {
    width: 100%;
    max-width: 1240px;
    margin: 0 auto;
    gap: clamp(42px, 5.2vh, 78px);
    padding-top: clamp(48px, 8.8vh, 108px);
    padding-bottom: clamp(58px, 9vh, 110px);
  }

  .home__bottom-bar {
    padding-bottom: 18px;
  }

  .home__login-btn {
    width: min(28vw, 360px);
    min-width: 220px;
    font-size: clamp(14px, 0.9vw, 18px);
    letter-spacing: 0.14em;
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);
  }

  .mod1 {
    max-width: 940px;
    gap: clamp(16px, 2vw, 30px);
  }

  .mod1__logo {
    width: min(52vw, 520px);
  }

  .mod1__subtitle {
    width: min(54vw, 610px);
  }

  .mod2 {
    max-width: 980px;
    gap: 8px;
  }

  .mod2__title {
    width: min(62vw, 700px);
  }

  .mod2__body {
    width: min(42vw, 500px);
    margin-top: clamp(10px, 1.2vw, 18px);
  }

  .mod2__digits {
    width: min(64vw, 760px);
    margin-top: clamp(24px, 3.2vw, 48px);
  }

  .mod3__title {
    font-size: clamp(30px, 2.25vw, 40px);
    letter-spacing: 0.1em;
  }

  .mod3__panel {
    width: 100%;
    max-width: 1080px;
    margin-left: auto;
    margin-right: auto;
  }

  .mod3__arc-node {
    width: 82px;
    height: 82px;
    margin-left: -41px;
    margin-top: -41px;
  }
}

@media (min-width: 1440px) {
  .home__main {
    max-width: 1320px;
  }

  .home__login-btn {
    width: min(24vw, 380px);
  }

  .mod3__panel {
    max-width: 1160px;
  }
}

.mod1 {
  width: 100%;
  max-width: min(720px, 100%);
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: clamp(14px, 3vw, 26px);
}

.mod1__logo {
  display: block;
  width: min(82vw, 480px);
  height: auto;
  max-width: 100%;
}

.mod1__subtitle {
  display: block;
  width: min(90vw, 540px);
  height: auto;
  max-width: 100%;
}

.home__bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: env(safe-area-inset-bottom, 0px);
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(8px, 2vw, 12px);
  padding-left: var(--main-pad-x);
  padding-right: var(--main-pad-x);
  padding-bottom: clamp(14px, 4vw, 28px);
  pointer-events: none;
}

.home__login-bar {
  display: flex;
  justify-content: center;
  width: 100%;
}

.home__icp {
  margin: 0;
  text-align: center;
  line-height: 1.4;
}

.home__icp-link {
  pointer-events: auto;
  font-size: clamp(10px, 2.4vw, 12px);
  color: rgba(255, 255, 255, 0.55);
  text-decoration: none;
  letter-spacing: 0.02em;
}

.home__icp-link:hover {
  color: rgba(255, 255, 255, 0.78);
}

.home__login-btn {
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: min(58vw, 300px);
  max-width: 100%;
  aspect-ratio: 689 / 155;
  padding: 0;
  border: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  color: #000000;
  font-size: clamp(13px, 3.1vw, 17px);
  font-weight: 600;
  letter-spacing: 0.2em;
  text-align: center;
  line-height: 1;
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    'PingFang SC',
    'Microsoft YaHei',
    sans-serif;
  transition:
    transform 0.18s cubic-bezier(0.33, 1, 0.68, 1),
    filter 0.18s ease,
    box-shadow 0.18s ease;
  will-change: transform;
}

.home__login-btn:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.65);
  outline-offset: 4px;
}

@media (hover: hover) {
  .home__login-btn:hover {
    filter: brightness(1.06);
    transform: translateY(-1px);
  }
}

.home__login-btn:active {
  transform: scale(0.96);
  filter: brightness(0.9);
}

.home__login-btn--logged-in {
  letter-spacing: 0.06em;
  font-size: clamp(12px, 2.85vw, 15px);
}

.mod2 {
  width: 100%;
  max-width: min(760px, 100%);
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0;
}

.mod2__title {
  display: block;
  width: min(92vw, 620px);
  height: auto;
  max-width: 100%;
}

.mod2__body {
  display: block;
  margin-top: clamp(14px, 3vw, 22px);
  width: min(76vw, 480px);
  height: auto;
  max-width: 100%;
}

.mod2__digits {
  display: block;
  margin-top: clamp(40px, 9vw, 88px);
  width: min(92vw, 640px);
  height: auto;
  max-width: 100%;
}

.mod3 {
  width: 100%;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: clamp(18px, 3.5vw, 28px);
}

.mod3__title {
  margin: 0;
  font-size: clamp(22px, 4.2vw, 34px);
  font-weight: 700;
  letter-spacing: 0.14em;
  color: rgba(255, 255, 255, 0.96);
  text-shadow:
    0 3px 10px rgba(6, 0, 46, 0.45),
    0 1px 2px rgba(255, 255, 255, 0.12);
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    'PingFang SC',
    'Microsoft YaHei',
    sans-serif;
}

.mod3__panel {
  position: relative;
  width: calc(100% + 2 * var(--main-pad-x));
  margin-left: calc(-1 * var(--main-pad-x));
  margin-right: calc(-1 * var(--main-pad-x));
  max-width: none;
}

.mod3__bg {
  position: relative;
  z-index: 0;
  display: block;
  width: 100%;
  height: auto;
}

.mod3__arc-mask {
  position: absolute;
  z-index: 2;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
}

/* 圆心：x 居中；y = bgCenterY + Ry - ARC_PIVOT_RAISE_PX（见脚本常量） */
.mod3__arc-pivot {
  position: absolute;
  width: 0;
  height: 0;
}

.mod3__arc-node {
  position: absolute;
  left: 0;
  top: 0;
  width: 58px;
  height: 58px;
  margin-left: -29px;
  margin-top: -29px;
  transform-origin: center center;
  will-change: transform;
  backface-visibility: hidden;
}

@media (min-width: 400px) {
  .mod3__arc-node {
    width: 68px;
    height: 68px;
    margin-left: -34px;
    margin-top: -34px;
  }
}

@media (min-width: 640px) {
  .mod3__arc-node {
    width: 80px;
    height: 80px;
    margin-left: -40px;
    margin-top: -40px;
  }
}

.mod3__arc-logo {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 1px 5px rgba(6, 0, 46, 0.32));
}

.mod4 {
  width: 100%;
  max-width: min(640px, 100%);
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  margin-top: -20px;
}

.mod4__stack {
  position: relative;
  width: min(78vw, 520px);
  max-width: 100%;
  padding-top: 0;
  overflow: hidden;
  border-radius: 12px;
  cursor: pointer;
}

.mod4__card {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(8, 4, 39, 0.28);
  user-select: none;
  -webkit-user-drag: none;
}

.mod4__card--next {
  position: absolute;
  left: 0;
  top: var(--policy-next-offset);
  z-index: 1;
  opacity: 0.68;
  filter: saturate(0.86) brightness(1.04);
  transform: none;
  transition:
    opacity 0.9s ease-out,
    filter 0.9s ease-out;
}

.mod4__card--next.is-hidden {
  opacity: 0;
}

.mod4__card--current {
  position: relative;
  left: 0;
  top: auto;
  z-index: 2;
  opacity: 1;
  margin-top: var(--policy-next-offset);
  transition: none;
}

.policy-modal {
  position: fixed;
  inset: 0;
  z-index: 60;
  background: rgba(4, 8, 20, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(12px, 4vw, 28px);
}

.policy-modal__panel {
  width: min(92vw, 760px);
  max-height: min(88vh, 920px);
  background: rgba(11, 16, 41, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.policy-modal__close {
  align-self: flex-end;
  margin: 10px 10px 4px;
  border: none;
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1;
  padding: 8px 12px;
  cursor: pointer;
}

.policy-modal__list {
  flex: 1;
  overflow-y: auto;
  padding: 6px 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.policy-modal__img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 10px;
}
</style>
